import { render, staticRenderFns } from "./EventTicketDetailSidebarSingleOfferContainer.vue?vue&type=template&id=d988b5aa&"
import script from "./EventTicketDetailSidebarSingleOfferContainer.vue?vue&type=script&lang=js&"
export * from "./EventTicketDetailSidebarSingleOfferContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports